import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['part'];

  markAnswered(partId) {
    const part = this._findPart(partId);

    if (!part) {
      return;
    }

    part.querySelector('[data-icon-answered]')?.classList.remove('hidden');
    part.querySelector('[data-icon-unanswered]')?.classList.add('hidden');
  }

  markUnanswered(partId) {
    const part = this._findPart(partId);

    if (!part) {
      return;
    }

    part.querySelector('[data-icon-answered]')?.classList.add('hidden');
    part.querySelector('[data-icon-unanswered]')?.classList.remove('hidden');
  }

  _findPart(partId) {
    return this.partTargets.find((t) => t.dataset.partId === String(partId));
  }
}
